module.exports = __webpack_public_path__ + "img/logoESGPiacitrening.3006f67d.png";